import { alpha } from '@mui/material';

import { legacyColors } from '~/legacyTheme';
import { theme } from '~/theme';

export const useSxStyles = () => {
  return {
    container: {
      maxWidth: '400px',
    },
    dialogPaper: {
      maxWidth: '900px',
    },
    formErrorMessage: {
      marginRight: theme.spacing(1),
    },
    selectStyle: {
      width: '100%',
    },
    dateInput: {
      width: '100%',
    },
    shortDate: {
      width: '55%',
    },
    vacBalContainer: {
      display: 'flex',
      alignItems: 'center',
      paddingTop: 0.5,
    },
    radioLabel: {
      fontSize: '13px',
      fontWeight: 'bold',
    },
    btnLeftMargin: {
      marginLeft: '5px',
    },
    warningMessage: {
      color: '#ff3300',
    },
    inputBottomMargin: {
      marginBottom: theme.spacing(2.5),
    },
    clearBtn: {
      marginLeft: theme.spacing(),
      marginBottom: theme.spacing(2.5),
    },
    helpIcon: {
      color: legacyColors.icon.help,
      '&:hover': {
        backgroundColor: alpha(legacyColors.icon.help, 0.1),
      },
      marginLeft: '10px',
    },
    tabError: {
      color: theme.palette.error.main,
      '&.Mui-selected': {
        color: theme.palette.error.main,
      },
    },
    saveButton: {
      color: '#090',
      fontWeight: 'bold',
    },
    confirmMessage: {
      color: '#090',
      fontWeight: 'bold',
    },
    divider: {
      margin: theme.spacing(2.5, 0),
    },
  };
};
